const moduleLabels = {
  USER: "Manage User",
  ROLE: "Manage Roles",
  INVESTOR: "Manage investors",
  WEALTH_PARTNER: "Manage Wealth partner",
  ICD: "Manage ICD's",
  BOND: "Manage Bonds",
  BOND_REQUEST: "Manage Bonds Request",
  PERMISSION: "Manage Permission",
  PLATFORM_MANAGER: "Manage Platform Manager",
  REIT: "Manage REIT",
  REPORT: "Manage Reports",
  BLOG: "Manage Blogs",
  FAQ: "Manage FAQs",
  VIDEO: "Manage investment Videos",
  DOC: "Manage Documents",
  ABOUT_US: "Manage About Us",
  FOUNDER_MESSAGE: "Manage Founder Message",
  HELP: "Manage Help Requests",
}

export { moduleLabels }
